// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__3yB5W"};